import Base from './Base'
import gsap from 'gsap'
import EmblaCarousel from 'embla-carousel'
import { evt, utils, store } from '@/core'

const { qs, qsa } = utils
const { dom, bounds } = store

export default class extends Base {
	onEnter() {
		super.onEnter()	
	}

	onLeave() {
		super.onLeave()
	}

	onEnterCompleted() {
		super.onEnterCompleted()

		console.log('colocaciones')
	}

	onLeaveCompleted() {
		super.onLeaveCompleted()
	}
}